import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Button,
    CircularProgress,
    Grid,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Paper,
    PaperProps
} from "@mui/material";
import ApiResources from "src/providers/ApiResources";
import Draggable from 'react-draggable';
import HttpClient from "src/providers/HttpClient";
import { useState } from "react";
import { useNotify } from 'react-admin';

interface FileRemoveModalProps {
    open: boolean;
    file: any;
    setOpen: any;
    onClose: any;
}

const PaperComponent = (props: PaperProps) => {
    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}
  
export const FileRemoveModal = (props: FileRemoveModalProps) => {
    const { open, setOpen, file, onClose } = props;
    const [loading, setLoading] = useState(false);
    const notify = useNotify();

    const removeFile = () => {
        try {
            setLoading(true);
            HttpClient(ApiResources.deleteMediaItem(), {
                method: "DELETE",
                body: JSON.stringify({file: file.file})
            }).then(({ json }) => {
                setLoading(false);

                if (json.code === 200) {
                    onClose(file);
                    setOpen(false);
                } else {
                    notify(json.message, { type: 'warning' });
                }
            }).catch(error => {
                notify(error.message, { type: 'error' });
            });
        } catch (e) {
            notify(e, { type: 'warning' });
        }
    }

    return (
        <Dialog
            onClose={() => setOpen(false)}
            open={open}
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth="sm"
        >
            <DialogTitle sx={{padding: "18px"}}>
                <Typography variant="body1" sx={{fontSize: "20px", fontWeight: "500"}}>Remove File</Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => setOpen(false)}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                    >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{padding: "18px !important"}}>
                <Grid container item sm={12} rowSpacing={1} columnSpacing={2}>
                    <Grid item sm={12} md={12}>
                        <Typography variant="subtitle1">{`Are you sure you want to remove "${file.file}"?`}</Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{padding: "18px"}}>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setOpen(false);
                    }}
                >
                    Cancel
                </Button>
                <Button 
                    variant="contained" 
                    type="submit" 
                    disabled={loading} 
                    onClick={() => removeFile()}
                >
                    {loading && <CircularProgress size={18} thickness={2} sx={{ fontSize: "18px", color: "#ffffff", marginRight: "8px"}}/>}
                    Remove
                </Button>
            </DialogActions>
        </Dialog>
    );
};
